import { getFilters } from "../../common/config/filters";
import { certificationBadgeResolver, isEcosystemCloudApp } from "../../common/utils/hitsStatsHelper";
import { ANALYTICS_SUBJECT_ID_DISCOVER_TILES, ANALYTICS_SUBJECT_ID_SEARCH_TILES, EVENT_CHANNEL, EVENT_SOURCE, OBJECT_TYPE_APP, TilesRenderedEvent } from "../constants/analytics/events";

const getEcosystemCloudAppTilesData = appTiles => {
  const ecosystemCloudAppTiles = appTiles.filter(isEcosystemCloudApp);
  const ecosystemCloudAppKeys = ecosystemCloudAppTiles.map(tile => ({
    key: tile.addonKey,
    isEcosystemCloudApp: true
  }));
  return {
    appKeys: ecosystemCloudAppKeys,
    totalEcosystemCloudAppTiles: ecosystemCloudAppTiles.length
  };
};

const getSearchTileCounts = (oldSearchData, newSearchData, featureFlags) => {
  const {
    enableCloudFortifiedAppsDiscovery
  } = featureFlags;
  const oldHits = oldSearchData.searchResults.hits;
  const newHits = newSearchData.searchResults.hits;
  const incrementalTilesRendered = oldSearchData !== null && oldSearchData !== void 0 && oldSearchData.loadingFreshSearchResults ? newHits : newHits.slice(oldHits.length);
  const {
    hasCloudFortifiedBadge,
    hasCloudSecurityBadge
  } = certificationBadgeResolver(enableCloudFortifiedAppsDiscovery);
  const incrementalTilesRenderedWithCloudSecurityBadge = incrementalTilesRendered.filter(hasCloudSecurityBadge);
  const incrementalTilesRenderedWithCloudFortifiedBadge = incrementalTilesRendered.filter(hasCloudFortifiedBadge);
  const {
    appKeys,
    totalEcosystemCloudAppTiles
  } = getEcosystemCloudAppTilesData(incrementalTilesRendered);
  return {
    totalTiles: incrementalTilesRendered.length,
    totalTilesWithCloudSecurityBadge: incrementalTilesRenderedWithCloudSecurityBadge.length,
    totalTilesWithCloudFortifiedBadge: incrementalTilesRenderedWithCloudFortifiedBadge.length,
    appKeys,
    totalEcosystemCloudAppTiles
  };
};

const getDiscoverTileCounts = (discoverData, featureFlags) => {
  const {
    enableCloudFortifiedAppsDiscovery
  } = featureFlags;
  let allTiles = [];
  Object.keys(discoverData).forEach(key => {
    allTiles = [...allTiles, ...discoverData[key].hits];
  });
  const totalTiles = allTiles.length;
  const {
    hasCloudFortifiedBadge,
    hasCloudSecurityBadge
  } = certificationBadgeResolver(enableCloudFortifiedAppsDiscovery);
  const totalTilesWithCloudSecurityBadge = allTiles.filter(hasCloudSecurityBadge).length;
  const totalTilesWithCloudFortifiedBadge = allTiles.filter(hasCloudFortifiedBadge).length;
  const {
    appKeys,
    totalEcosystemCloudAppTiles
  } = getEcosystemCloudAppTilesData(allTiles);
  return {
    totalTiles,
    totalTilesWithCloudSecurityBadge,
    totalTilesWithCloudFortifiedBadge,
    appKeys,
    totalEcosystemCloudAppTiles
  };
};

const fireAnalyticsEvent = createAnalyticsEvent => (actionSubjectId, objectId, attribute) => {
  createAnalyticsEvent({
    eventType: TilesRenderedEvent,
    objectType: OBJECT_TYPE_APP,
    source: EVENT_SOURCE,
    objectId,
    actionSubjectId,
    attributes: attribute
  }, EVENT_CHANNEL);
};

export const trackTileRenders = (props, newProps) => {
  const oldSearchData = props.search;
  const newSearchData = newProps.search;
  const oldHits = oldSearchData.getIn(['searchResults', 'hits']);
  const newHits = newSearchData.getIn(['searchResults', 'hits']);
  const oldDiscoverData = props.discover.get('data');
  const newDiscoverData = newProps.discover.get('data');
  const fireEvent = fireAnalyticsEvent(props.fireAnalyticsEvent);
  const searchTerm = newProps.filters.get(getFilters().getIn(['query', 'key']));
  const featureFlags = {
    enableCloudFortifiedAppsDiscovery: props.enableCloudFortifiedAppsDiscovery
  };

  if (newDiscoverData && newDiscoverData !== oldDiscoverData) {
    fireEvent(ANALYTICS_SUBJECT_ID_DISCOVER_TILES, 0, getDiscoverTileCounts(newDiscoverData.toJS(), featureFlags));
  } else if (newHits && newHits !== oldHits) {
    fireEvent(ANALYTICS_SUBJECT_ID_SEARCH_TILES, newSearchData.get('currentPage'), { ...getSearchTileCounts(oldSearchData.toJS(), newSearchData.toJS(), featureFlags),
      searchTerm
    });
  }
};